import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import tailorMadeService from "./tailorMadeService";

// GET ALL
export const getTailorMades = createAsyncThunk(
    "tailorMade/getTailorMades",
    async (_, thunkAPI) => {
        try {
            return await tailorMadeService.getTailorMades();
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

// CREATE
export const createTailorMade = createAsyncThunk(
    "tailorMade/createTailorMade",
    async (data, thunkAPI) => {
        try {
            return await tailorMadeService.createTailorMade(data);
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

// GET SINGLE
export const getTailorMade = createAsyncThunk(
    "tailorMade/getTailorMade",
    async (id, thunkAPI) => {
        try {
            return await tailorMadeService.getTailorMade(id);
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

// UPDATE
export const updateTailorMade = createAsyncThunk(
    "tailorMade/updateTailorMade",
    async ({ id, data }, thunkAPI) => {
        try {
            return await tailorMadeService.updateTailorMade(id, data);
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

// DELETE
export const deleteTailorMade = createAsyncThunk(
    "tailorMade/deleteTailorMade",
    async (id, thunkAPI) => {
        try {
            return await tailorMadeService.deleteTailorMade(id);
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

// STATUS UPDATE
export const updateTailorMadeStatus = createAsyncThunk(
    "tailorMade/updateTailorMadeStatus",
    async (id, thunkAPI) => {
        try {
            return await tailorMadeService.updateTailorMadeStatus(id);
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

// QUOTE APPROVAL
export const approveQuote = createAsyncThunk(
    "tailorMade/approveQuote",
    async ({ tailorId, quoteId }, thunkAPI) => {
        try {
            return await tailorMadeService.approveQuote({ tailorId, quoteId });
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const resetState = createAction("tailorMade/reset");

const initialState = {
    tailorMades: [],
    tailorMade: null,
    isError: false,
    isLoading: false,
    isSuccess: false,
    message: "",
};

const tailorMadeSlice = createSlice({
    name: "tailorMade",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder

            // GET ALL
            .addCase(getTailorMades.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getTailorMades.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.tailorMades = action.payload.data;
            })
            .addCase(getTailorMades.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })

            // CREATE
            .addCase(createTailorMade.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.tailorMade = action.payload;
            })

            // GET SINGLE
            .addCase(getTailorMade.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.tailorMade = action.payload.data;
            })

            // UPDATE
            .addCase(updateTailorMade.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.tailorMade = action.payload;
            })

            // DELETE
            .addCase(deleteTailorMade.fulfilled, (state) => {
                state.isLoading = false;
                state.isSuccess = true;
            })

            // STATUS UPDATE
            .addCase(updateTailorMadeStatus.fulfilled, (state) => {
                state.isLoading = false;
                state.isSuccess = true;
            })

            // RESET
            .addCase(resetState, () => initialState);
    },
});

export default tailorMadeSlice.reducer;